
















































import { Component, Vue, Watch } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants, Models } from "@/core/Export";
import store from "@/store";
import { date } from "quasar";
@Component({
  components: {},
})
export default class EmployeeApprovalsFiles extends Vue {
  employeeFilesDataSource: Array<any>;
  constructor() {
    super();
    this.employeeFilesDataSource = [];
  }

  created() {
    this.onGetEmployeeFiles();
  }

  @Watch("date")
  onGetEmployeeFiles() {
    this.appEnv.isBusy = true;
    apiService
      .getEmployeeFiles(this.employeeId, this.year, this.month, this.day)
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeeFilesDataSource = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onOpenFileToPreview(file: object) {
    this.onGetFile(file);
  }

  onGetFile(file: any) {
    this.appEnv.isBusy = true;
    apiService
      .getFiles(this.employeeId, file.fileId, this.filesHeaders)
      .then((res) => {
        res
          .blob()
          .then((blob) => {
            if (this.appEnv.IsMobileApp) {
              this.appEnv.saveBlobToFile(file.fileName, blob);
            } else {
              let fileUrl = window.URL.createObjectURL(blob);
              window.open(fileUrl, "_blank");
            }
          })
          .catch((err) => {
            this.appEnv.isBusy = false;
          });
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onCloseEmployeeApprovalsFilesDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
  }

  get filesHeaders() {
    return {
      customercode: this.appEnv.customerCode,
      accesstoken: this.appEnv.UserInfo.accessToken,
    };
  }

  get date() {
    return this.appEnv.formatDate(
      this.drawerParams.date,
      false,
      this.$q.screen.xs
    );
  }

  get day() {
    return parseInt(date.formatDate(this.drawerParams.date, "DD"));
  }

  get month() {
    return parseInt(date.formatDate(this.drawerParams.date, "MM"));
  }

  get year() {
    return parseInt(date.formatDate(this.drawerParams.date, "YYYY"));
  }

  get employeeId() {
    return this.drawerParams.employeeId;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
